<template>
	<div class="pcBatteryBox">
		<div class="goback" @click="goback">
			<img class="location" src="@/assets/images/site/arrow_small.png" alt="">
			返回
		</div>
		<batteryBox
			v-show="showBatteryBox"
			@changeParentShow="changeParentShow"
			style="transform: scale(0.6) translate(0, -15%)" />
		<batteryBag
			v-show="!showBatteryBox"
			@changeParentShow="changeParentShow"
			style="transform:scale(0.8)" />
		<Overview
			class="pcbatteryBoxL"
			:batteryInfo="batteryInfo" />

		<SiteType
			class="pcbatteryBoxR"
			:batteryInfo="batteryInfo" />
	</div>
</template>

<script>
	//综合态势
	import Overview from "./overview"
	import batteryBox from "./batteryBox"
	import batteryBag from "./batteryBag"
	import SiteType from "./siteType"

	export default {
		data() {
			return {
				batteryInfo: {},
				showBatteryBox: true,
			};
		},
		components: {
			Overview,
			batteryBox,
			SiteType,
			batteryBag,
		},
		props: {

		},
		watch: {

		},
		mounted() {
			// 0  乘用车  1 商用车
			this.showBatteryBox = this.$route.query.vehicleClassification * 1 === 1 ? true : false;
		},
		methods: {
			getData(data) {
				// this.centerBatterInfo(data)
			},
			//控制电池箱、电池包显示隐藏
			changeParentShow() {
				console.log(this.showBatteryBox, 'showBatteryBox')
				this.showBatteryBox = !this.showBatteryBox;
			},

			goback() {
				window.history.back(-1)
			}
		}
	}
</script>

<style lang="scss" scoped>
.pcBatteryBox {
	position: relative;
	.go-back {
		left: 20%;
		position: absolute;
	}
	.pcbatteryBoxL, .pcbatteryBoxR {
		position: absolute;
		width: 20%;
		top: 10%;
	}
	.pcbatteryBoxL {
		left: 0;
	}
	.pcbatteryBoxR {
		right: 0;
	}
	.goback {
			position: absolute;
			top: 10px;
			left: 450px;
			width: 100px;
			height: 50px;
			// border: 1px solid #1A7683;
			background: linear-gradient(180deg, rgba(14,134,139,0.88) 0%, rgba(0,43,41,0.6) 100%);
			display: flex;
			align-items: center;
			justify-content: center;
			border-radius: 4px;
			cursor: pointer;
			.location {
				width: 20px;
				height: 20px;
				margin-right: 15px;
				transform: rotate(180deg);
			}
		}
}
</style>